import { render, staticRenderFns } from "./AdjudicatePostulatedProject.vue?vue&type=template&id=7f82087e"
import script from "./AdjudicatePostulatedProject.vue?vue&type=script&lang=js"
export * from "./AdjudicatePostulatedProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports